<template>
  <div class="csv-upload-config">
    <div class="content">
      <template v-if="!success">
        <el-row>
        <el-col :span="12">

        </el-col>
        <el-col :span="12"><div class="grid-content bg-purple-light"></div></el-col>
      </el-row>

        <el-row :gutter="20" class="csv-upload-config__list">
          <el-col :span="24">
            <el-input type="text" v-model="form.venueName" class="peiso-input-default" placeholder="Enter Site Name" :class="{'is-error' : form.venueName == ''}" clearable />
          </el-col>

        </el-row>

          <div class="bottom-button d-flex gap-30">
            <el-button type="peiso-white-border-only w-100" @click="buttonAction('back')">Back</el-button>
            <el-button v-if="!loading" type="peiso-primary-pink-border-only w-100" @click="confirm">Connect</el-button>
            <el-button v-if="loading" type="peiso-primary-pink-border-only w-100"><i class="el-icon-loading"></i>
              Loading...</el-button>
          </div>
      </template>
      <template v-else>
          <div class="csv-upload-config__success">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
            </svg>

            <h6>Successfully linked with {{ selectedRevenuePlatform }}.</h6>
          </div>
      </template>

    </div>
</div>
</template>


<script>
import api from '@/api/api';
import utils from '@/utils/utils';

export default {
  props: {
    selectedRevenuePlatform: {
      type: String,
      default: 'idealpos'
    }
  },
  data() {
    return {
      step: 1,
      loading: false,
      success: false,
      form: {
        venueName: ''
      }
    }
  },
  methods: {
    buttonAction(action, data = null) {
      this.$emit(action, data)
    },
    async confirm() {
      this.loading = true;
      
      try {

          if (this.form.venueName.trim() == '') {
            utils.alert2('', 'Site name is required' ,'error');
            this.loading = false;
            return;
          }

          const res = await api.csvUploadBinding(this.selectedRevenuePlatform, {
              venueName: this.form.venueName
          });

          this.loading = false;
          this.success = true;
          setTimeout(() => {
            this.$emit('csv-bind', true)
          }, 1000)

        if (res.data.code !== 0) {
          this.loading = false;
          this.success = false;
          utils.alert2('', `Error ${this.selectedRevenuePlatform} binding configuration`, 'error')
        }
      } catch (error) {
        if (error && error.response && error.response.data) {
          this.loading = false;
          this.success = false;
          utils.alert2('', error.response.data.message, 'error')
        }
      
      }
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss">
@import 'static/scss/colors.scss';
@import 'static/scss/fonts/fonts';
.el-dialog__header {
  text-align: center;
}
.csv-upload-config {
    .peiso-input-default {
      margin-bottom: 1rem;
      border-radius: 5px !important;
      .el-input__inner {
        border-radius: 5px !important;
      }
    }
    &__success {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex-direction: column;
      gap: 20px;
      svg {
        fill: #2fb357;

      }


      h6 {
        font-size: 16px;
        color: #fff;
      }
    }
    &__list {
      margin-bottom: 2rem;

      &--item {
        margin-bottom: 1rem;
        .el-radio {
          width: 100%;
        }

        .el-radio.is-bordered.is-checked  {
          color: var(--primary-color);
          border-color: var(--primary-color);
        }
        .el-radio__input.is-checked .el-radio__inner  {
          border-color: var(--primary-color);
          background: var(--primary-color);
        }

        .el-radio__input.is-checked+.el-radio__label {
          color: var(--primary-color);
        }

        .el-radio.is-bordered {
          background-color: var(--background-color-3) !important;
          border: 1px solid var(--background-color-3);
        }

        .el-radio__label {
          font-size: 16px;
          font-weight: 600;
          color: var(--text-color);
        }

        .el-radio.is-bordered {
            padding: 18px 20px 0 20px;
            border-radius: 5px;
            height: 55px;
        }

      }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/modal/csvUploadConfiguration.vue